import { parseDate } from '../utils/assessmentWindowsUtils';

const DATE_OPTIONS = { year: '2-digit', month: '2-digit', day: '2-digit' };
/**
 * Format benchmark date to locale string (01/01/19)
 * @param {Date|String} date Date object or string which can be parsed to Date object
 * @returns {String} string with formatted date
 */
const localizeDate = date => parseDate(date).toLocaleString('en-US', DATE_OPTIONS);

export default localizeDate;
